
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/add-service",
      function () {
        return require("private-next-pages/add-service.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/add-service"])
      });
    }
  